export { default } from './GridSharedAccess.vue'
